export const SEQUENCE_USED_SOUND = 'SEQUENCE_USED_SOUND';
export const PROJECT_MASTER_EXPORTED = 'PROJECT_MASTER_EXPORTED';
export const PRESET_RATED = 'PRESET_RATED';
export const SOUND_RATED = 'SAMPLE_RATED';
export const SEQUENCE_BPM = 'SEQUENCE_BPM';
export const PRESET_RESAMPLED = 'PRESET_RESAMPLED'; // original preset -> newly sampled preset
